"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeEnrichmentValue = exports.escapeTokenValue = void 0;
/**
 * Fingerprint blocks are newline-joined and tokens are bracket-delimited, so a
 * raw value carrying either forges structure. Newlines are flattened rather
 * than escaped, which collapses `a\nb` onto `a b` — accepted, because a field
 * that spans lines is content, not identity.
 *
 * Without this, a raw field value containing `[` or `]` can forge additional
 * token boundaries, making two structurally distinct nodes serialize to
 * byte-identical fingerprints.
 *
 * MUST be injective over `\`, `[` and `]` — escape the escape character FIRST.
 * Otherwise two distinct raw inputs map to the same escaped output, introducing
 * NEW collisions instead of removing them (without escaping `\` first, raw
 * `\[` and raw `[` both become `\[`). The newline flattening above is the one
 * collision this function accepts by design.
 */
const escapeTokenValue = (value) => value
    .replace(/\n/g, ' ')
    .replace(/\\/g, '\\\\')
    .replace(/\[/g, '\\[')
    .replace(/\]/g, '\\]');
exports.escapeTokenValue = escapeTokenValue;
/**
 * Wider than `escapeTokenValue` because an enrichment descriptor nests three
 * levels of joins (`;` between parts, `,` between entries, `|` between levels),
 * any of which a raw class name or short label can forge.
 *
 * MUST be injective over that delimiter set — escape the escape character
 * FIRST, for the same reason `escapeTokenValue` does, and with the same
 * accepted newline collision.
 */
const escapeEnrichmentValue = (value) => value
    .replace(/\n/g, ' ')
    .replace(/\\/g, '\\\\')
    .replace(/[[\]|,;:\u00d7]/g, m => `\\${m}`);
exports.escapeEnrichmentValue = escapeEnrichmentValue;
//# sourceMappingURL=tokenEscape.js.map